import tc from 'tinycolor2';
import { injectGlobal } from '@bd/bdui-styles/emotion';

export const originalColors = {
  brand1: '#26312D', /* darker brand color */
  brand2: '#193E30', /* lighter brand color */
  brand3: '#036B43', /* additional brand color */
  brand4: '#036B43', /* additional brand color */
  black: '#000000',
  neutral: '#EEEEEE',
  white: '#FFFFFF',
  body: '#2B2B2B',
  error: 'red', /* error message */
};

const colors = {};

(() => {
  Object.keys(originalColors).forEach(name => {
    const color = originalColors[name];
    colors[name] = color;
    colors[`${name}Dark`] = tc(color).darken(3).toString();
    colors[`${name}Darker`] = tc(color).darken(6).toString();
    colors[`${name}Darkest`] = tc(color).darken(9).toString();
    colors[`${name}Light`] = tc(color).lighten(3).toString();
    colors[`${name}Lighter`] = tc(color).lighten(6).toString();
    colors[`${name}Lightest`] = tc(color).lighten(9).toString();
  });

  Object.keys(colors).forEach(name => {
    const color = colors[name];
    colors[`${name}TextLarge`] = tc.isReadable(color, '#FFFFFF', { level: 'AA', size: 'large' }) ? '#FFFFFF' : '#000000';
    colors[`${name}TextSmall`] = tc.isReadable(color, '#FFFFFF', { level: 'AA', size: 'small' }) ? '#FFFFFF' : '#000000';
    colors[`${name}Text`] = colors[`${name}TextSmall`];
  });

  const colorClasses = Object.keys(colors).map(color => (`
    .text-${color} {
      color: ${colors[color]};
    }
    .bg-${color} {
      background-color: ${colors[color]};
    }
  `)).join(' ');

  injectGlobal(colorClasses);
})();


export default colors;



// WEBPACK FOOTER //
// ./src/styles/colors.js